import * as types from '../../actions/ActionTypes.js';

const INITIAL_STATE = {
    isFetching: false,
    hasFetched: false,
    entity: {
        value: ''
    },
    systemStatus: null
};

const receiveSystemMessage = (state, action) => {
    return {
        ...state,
        entity: {
            value: action.systemMessage.value
        },
        isFetching: false,
        hasFetched: true,
        lastUpdated: action.receivedAt
    };
};

const fetchSystemMessage = (state) => {
    return {
        ...state,
        isFetching: true
    };
};

const receiveSystemStatus = (state, action) => {
    return {
        ...state,
        systemStatus: action.systemStatus
    };
};

const handlers = {
    [types.RECEIVE_SYSTEM_MESSAGE]: receiveSystemMessage,
    [types.FETCH_SYSTEM_MESSAGE]: fetchSystemMessage,
    [types.RECEIVE_SYSTEM_STATUS]: receiveSystemStatus
};

export const getSystemMessage = (state) => {
    return state.systemMessage.entity;
};

export const getSystemMessageIsFetching = (state) => {
    return state.systemMessage.isFetching;
};

export const getSystemMessageHasFetched = (state) => {
    return state.systemMessage.hasFetched;
};

export const getSystemStatus = (state) => {
    return state.systemMessage.systemStatus;
};

export default function systemMessage(state = INITIAL_STATE, action = {}) {
    const handler = handlers[action.type];

    if (!handler) return state;
    return handler(state, action);
}
